import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.shipmentView.shipmentInfoSection.title',
    defaultMessage: 'Information',
    description: 'Title of the shipment info section',
  },
  properties: {
    createdAt: {
      id: 'properties.createdAt',
      defaultMessage: 'Created at',
      description: 'Title of the property created at',
    },
    expectedAt: {
      id: 'properties.expectedAt',
      defaultMessage: 'Expected at',
      description: 'Title of the property expected at',
    },
    expectedShipAt: {
      id: 'properties.expectedShipAt',
      defaultMessage: 'Expected ship at',
      description: 'Title of the property expected ship at',
    },
    shipAt: {
      id: 'properties.shipAt',
      defaultMessage: 'Ship at',
      description: 'Title of the property ship at',
    },
    updatedAt: {
      id: 'properties.updatedAt',
      defaultMessage: 'Updated at',
      description: 'Title of the property updated at',
    },
  },
};

export default defineMessages(translations);
